import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initPwa } from "@/lib/pwa";
import { startOfflineSync } from "@/lib/offlineQueue";

// Register service worker + start the offline replay loop for clock actions.
initPwa();
startOfflineSync();

// Swallow the benign ResizeObserver loop warning so the CRA dev overlay
// doesn't paint a full-page error and block clicks (dev-only noise).
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
